<button class="przycisk-mydlo flex justify-center items-center" attr.aria-label="{{label}}" matTooltip="{{label}}">
  <mat-icon [svgIcon]="ikona"></mat-icon>
</button>
